import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Log PWA readiness checks
console.log('=== PWA DIAGNOSTICS ===');
console.log('Service Worker supported:', 'serviceWorker' in navigator);
console.log('HTTPS:', window.location.protocol === 'https:');
console.log('Manifest link:', document.querySelector('link[rel="manifest"]'));
console.log('Current URL:', window.location.href);

// Listen for beforeinstallprompt
let installPromptEvent: any = null;
window.addEventListener('beforeinstallprompt', (e) => {
  console.log('✅ beforeinstallprompt event FIRED!');
  installPromptEvent = e;
  e.preventDefault();
});

// Check after 5 seconds
setTimeout(() => {
  console.log('After 5s - Install prompt received:', !!installPromptEvent);
}, 5000);

// Check after 30 seconds
setTimeout(() => {
  console.log('After 30s - Install prompt received:', !!installPromptEvent);
}, 30000);

// Check after 60 seconds
setTimeout(() => {
  console.log('After 60s - Install prompt received:', !!installPromptEvent);
  if (!installPromptEvent) {
    console.error('❌ Install prompt NEVER fired on this device/browser');
    console.log('Possible reasons:');
    console.log('1. App already installed');
    console.log('2. Not enough user engagement');
    console.log('3. Service worker not active');
    console.log('4. Manifest invalid');
    console.log('5. Device/Chrome restrictions');
  }
}, 60000);

// Register service worker for PWA functionality
serviceWorkerRegistration.register({
  onSuccess: () => {
    console.log('✅ PWA: Service worker registered successfully');
    console.log('SW registered at:', new Date().toISOString());
  },
  onUpdate: () => console.log('PWA: New content available, please refresh'),
});
